import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { I18NextModule } from 'angular-i18next';
import { TextEllipsisComponent } from 'mbs-ui-kit';
import { StorageTypeIconPipe } from 'mbs-ui-shared@utils/pipes/storage-type-icon.pipe';
import { CalculatedPropertyStorage } from 'wizards/services/wizard-steps.service';

@Component({
  selector: 'mbs-retention-policy-storage-info',
  imports: [CommonModule, TextEllipsisComponent, NgbTooltipModule, I18NextModule, StorageTypeIconPipe],
  template: `
    <ng-container>
      @if (storage().immutabilityPeriodDays) {
        <div class="mb-2" [id]="storageHasObjectLocke2e()">
          <span class="d-flex align-items-center">
            <span
              class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
              <span class="ico ico-Lock"></span>
              <span class="ml-1">
                {{ 'wizards:common.objectLockIsEnabled' | i18next: { format: 'uppercase', count: storage().immutabilityPeriodDays } }}
              </span>
            </span>
          </span>
        </div>
      }

      <span class="d-flex align-items-center overflow-hidden mb-2">
        @let storageItem = storage();
        <span class="mbs-storage mbs-storage-sm mbs-storage_{{ storageItem.type | storageIcon: false : !storageItem.isLocal }} mr-2"></span>
        <mbs-text-ellipsis [tooltip]="storageItem.name">{{ storageItem.name }}</mbs-text-ellipsis>
      </span>
    </ng-container>
  `
})
export class RetentionPolicyStorageInfoComponent {
  public storage = input.required<Partial<CalculatedPropertyStorage>>();
  public storageHasObjectLocke2e = input<string>();
}
